import { useEffect, useState } from "react";
import { useHub } from "../../../../core/Global";
import { API_ROUTES } from "../../../../core/Constants";
import { TechWorkingHoursModel } from "../../../accounts/models/TechWorkingHoursModel";
import { getTechAvailability } from "../../../accounts/utils/techAvailability";
import Icon from "../../../../components/base/Icon";
import TechWorkingHoursDrawer from "../../../chat/components/TechWorkingHoursDrawer";

interface IProps {
    techId?: string
    className?: string
}

// Compact chip shown next to the Technician field on the job form when the
// selected technician is currently outside their working hours. Clicking it
// opens the full working-hours drawer.
export default function TechAvailabilityIndicator(props: IProps) {

    const hub = useHub()
    const [model, modelSet] = useState<TechWorkingHoursModel>()
    const [now, nowSet] = useState<Date>(new Date())
    const [showDrawer, showDrawerSet] = useState<boolean>(false)

    useEffect(() => {
        if (!props.techId) {
            modelSet(undefined)
            return
        }
        hub.Get(`${API_ROUTES.Technicians}workinghours/${props.techId}`, res => modelSet(res.data))
    }, [props.techId])

    // Re-evaluate open/closed periodically so it stays accurate near a boundary.
    useEffect(() => {
        const timer = setInterval(() => nowSet(new Date()), 30000)
        return () => clearInterval(timer)
    }, [])

    if (!props.techId || !model) return <></>

    const { alwaysAvailable, openNow } = getTechAvailability(model, now)

    // Only flag the "not currently working" case; stay silent otherwise.
    if (alwaysAvailable || openNow !== false) return <></>

    return (
        <>
            <span className={`badge badge-light-warning fw-semibold cursor-pointer ${props.className ?? ""}`}
                title="View working hours"
                onClick={() => showDrawerSet(true)}>
                <Icon icon="clock" className="me-1" size={11} />
                Outside hours
            </span>
            {
                showDrawer &&
                <TechWorkingHoursDrawer techId={props.techId} onClose={() => showDrawerSet(false)} />
            }
        </>
    )
}
